const defaultTransform = (node) => {
  return node["$ref-value"];
};
const getResolvedRef = (node, transform = defaultTransform) => {
  if (typeof node === "object" && node !== null && "$ref" in node) {
    return transform(node);
  }
  return node;
};
export {
  getResolvedRef
};
//# sourceMappingURL=get-resolved-ref.js.map
